import {createClient} from 'next-sanity';

import {apiVersion, dataset, projectId} from './sanity.api';

export const client = createClient({
	dataset,
	projectId,
	apiVersion,
	useCdn: false,
	perspective: 'published',
	token: process.env.SANITY_API_TOKEN,
});

export const formClient = createClient({
	dataset,
	projectId,
	apiVersion,
	useCdn: false,
	perspective: 'published',
	token: process.env.SANITY_API_EDITOR_TOKEN,
});
